import React, { ReactElement } from 'react';
import { useLocation, useParams } from 'react-router';
import { Heading, Loader } from 'idsk-react-components';
import { NotFoundPage } from 'slovlex-idsk-react-components';
import Layout from '../Layout';
import './editPripomienkaAdminPage.scss';
import ClassType from '../../model/pripomienka/ClassType';
import { EditPripomienkaAdmin } from '../../module/CreateAndUpdatePripomienkaAdmin';
import routes from '../../routing/routes';
import { usePripomienkaDetail } from '../../module/PripomienkaDetail';
import UserRole from '../../model/currentuser/UserRole';
import SecuredPage from '../../module/SecuredPage';

interface Props {
  classType: ClassType;
}

export default ({ classType }: Props): ReactElement => {
  const { pathname } = useLocation();
  const {
    type,
    year,
    index,
    uuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();

  const {
    pripomienkaDetail,
    pripomienkaStatus,
  } = usePripomienkaDetail({ classType });

  if (pripomienkaStatus?.responseCode === 404) {
    return (
      <Layout withoutNavLinks>
        <NotFoundPage />
      </Layout>
    );
  }

  return (
    <Layout
      isHromadna={classType === ClassType.HROMADNA_PRIPOMIENKA}
      breadcrumbRouteList={[{
        heading: routes.pripomienky.detail.name,
        to: classType === ClassType.HROMADNA_PRIPOMIENKA
          ? routes.hromadnePripomienky.detail.withParams(type, year, index, uuid)
          : routes.pripomienky.detail.withParams(type, year, index, uuid),
      },
      {
        heading: routes.admin.pripomienky.edit.name,
        to: pathname,
      }]}
    >
      <SecuredPage allowForRoles={[UserRole.SUPERADMIN]}>
        <Loader loading={pripomienkaStatus.loading}>
          {pripomienkaDetail && (
            <div className="edit-pripomienka-admin-page">
              <Heading size="l">
                Úprava pripomienky (admin)
              </Heading>
              <EditPripomienkaAdmin
                classType={classType}
                pripomienkaDetail={pripomienkaDetail}
              />
            </div>
          )}
        </Loader>
      </SecuredPage>
    </Layout>
  );
};
